<template>
  <div>
    <div class="login-container" style="padding-bottom: 10%">
      <slot/>
    </div>

    <div class="container" style="position: absolute; bottom: 40px; width: 100%; height: 10%">
      <div class="row">
        <div class="col-md-12 text-center">
          <div style="color:#aaa;margin-bottom: 10px;">Оператор сервиса</div>
          <a href="https://konversta.com">
            <img src="../../public/img/konversta.png" alt style="width: 150px;">
          </a>
          <div style="color:#aaa;margin-top: 10px;">
            Продолжая использовать сайт, вы&nbsp;даете согласие на&nbsp;обработку файлов cookie.
            Ознакомьтесь с&nbsp;<a href="https://www.konversta.com/ru/policy/">Политикой в&nbsp;отношении обработки
            персональных данных</a>.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'LoginLayout',
  metaInfo: {
    title: process.env.VUE_APP_LOGIN_TITLE_HEADER
  }
}
</script>
